import { render, staticRenderFns } from "./RmpFile.vue?vue&type=template&id=4af16ba7&scoped=true"
import script from "./RmpFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpFile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpFile.vue?vue&type=style&index=0&id=4af16ba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af16ba7",
  null
  
)

export default component.exports